module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/status_games_icons/active-d4ef98dd209b0d4e634a0b03688c1f54.svg";